import React, { useState } from "react";
import CustomFieldModal from "./CustomFieldModal";
import EditCustomFieldModal from "./EditCustomFieldModal";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import useCustomField from "../../../../../hooks/useCustomField/UseCustomField";
import useUpdateCustomField from "../../../../../hooks/useCustomField/useUpdateCustomField";
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import useEditCustomField from "../../../../../hooks/useCustomField/useEditCustomField";
import axios from "axios";
import { FaMinus } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import FieldEditModal from "./FieldEditModal/FieldEditModal";

const Executives = ({
  dynamicFields = [],
  hidden,
  onFieldChange, // Accept onFieldChange prop from parent
  require,
  data,
  setData,
  Message,
}) => {
  const [executives, setExecutives] = useState([
    { id: 1, name: "Executive 1" },
  ]);
  const [showModal, setShowModal] = useState(false); // State for add field modal
  const [showDeleteModal, setShowDeleteModal] = useState(false); // State for delete confirmation modal
  const [fieldToDelete, setFieldToDelete] = useState(null); // State for the field to delete
  const [division, setDivision] = useState(""); // State for division
  const [message, setMessage] = useState({ type: "", text: "" }); // State for success/error messages

  const { submitCustomField } = useCustomField();
  const { updateCustomField } = useUpdateCustomField();
  const apiUrls = process.env.REACT_APP_API_URLS;

  const {
    showEditModal,
    selectedField,
    handleOpenEditModal,
    handleCloseEditModal,
    handleSubmitUpdateField,
  } = useEditCustomField();

  // Handle form submission for adding a new field
  const handleSubmit = async (data) => {
    const result = await submitCustomField(data);
    if (result.success) {
      toast.success("Field is Added Succefully", {
        position: "top-right",
        autoClose: 600,
      });

      setShowModal(false);
      setTimeout(() => {
        window.location.reload();
      }, 700);
      window.location.reload(); // Reload the page on success
    } else {
      toast.error(result.message, {
        position: "top-right",
        autoClose: 1000,
      });
      setShowModal(false);
    }
  };

  // Open Add Field Modal
  const handleOpenModal = () => {
    setDivision("executive"); // Set division value here
    setShowModal(true);
  };

  // Open Delete Confirmation Modal
  const handleDeleteField = (field) => {
    setFieldToDelete(field);
    setShowDeleteModal(true);
  };

  // Confirm deletion of the field
  const handleConfirmDelete = async () => {
    if (fieldToDelete) {
      try {
        const response = await axios.delete(
          `${apiUrls}/buyer_settings/custom-fields/${fieldToDelete.id}/`
        );

        if (response.status === 204 || response.status === 200) {
          setMessage({ type: "success", text: "Field deleted successfully!" });
          window.location.reload(); // Reload the page on success
        } else {
          setMessage({ type: "error", text: "Failed to delete the field." });
        }
      } catch (error) {
        setMessage({
          type: "error",
          text: "An error occurred while deleting the field.",
        });
      } finally {
        setShowDeleteModal(false);
        setFieldToDelete(null);
      }
    }
  };

  // Close Delete Confirmation Modal
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setFieldToDelete(null);
  };

  // Handle input changes and notify parent
  const handleInputChange = (e, field) => {
    const { value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [field.column_name]: value,
    }));
    onFieldChange(field.column_name || field.name, value); // Notify parent of the change
  };

  // Add a new executive section
  const addExecutive = () => {
    const newExecutive = {
      id: executives.length + 1,
      name: `Executive ${executives.length + 1}`,
    };
    setExecutives([...executives, newExecutive]);
  };

  // Delete an executive section
  const deleteExecutive = (id) => {
    setExecutives(executives.filter((exec) => exec.id !== id));
  };

       const [isEditModalOpen, setEditModalOpen] = useState(false)
  const [formData, setFormData] = useState({
    label: '',
    placeholder: '',
    type: 'required',
  });

  const handleSave = () => {
    console.log("Form Data Saved:", formData);
    setEditModalOpen(false);
  };

  return (
    <>
      {executives.map((executive) => (
        <div
          key={executive.id}
          className="border-2 border-gray-200 shadow-lg rounded-md p-6 mt-8"
        >
          <h2 className="text-lg font-semibold w-full flex items-center justify-between mb-4">
            <span className="underline">{executive.name}</span>
            {executive.id > 1 && (
              <button
                className="bg-red-500 text-white font-bold px-4 py-1 rounded-[5px] ml-2"
                onClick={() => deleteExecutive(executive.id)}
              >
                <FaMinus />
              </button>
            )}
          </h2>

          {/* Display success/error messages */}
          {/* {message.text && (
            <div
              className={`p-2 mb-4 rounded-md ${
                message.field_type === "success"
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-700"
              }`}
            >
              {message.text}
            </div>
          )} */}

          {/* Static Fields */}
          <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <div className="flex items-center justify-between">
              <label htmlFor="name" className="block">
                Name<span className="text-red-500">*</span>
              </label>
               {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Name",placeholder:"Enter Your name"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
              </div>
              <input
                type="text"
                id="name"
                value={data?.name || ""}
                name="name" // Add a name for the field
                placeholder="Enter your Name"
                className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
                onChange={(e) => handleInputChange(e, { column_name: "name" })} // Notify parent of changes
                disabled={require}
                readOnly={require}
              />
            </div>

            <div>
              <div className="flex items-center justify-between">
              <label htmlFor="designation" className="block">
                Designation
              </label>
               {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Designation",placeholder:"Enter Your Designation"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
              </div>
              <input
                type="text"
                id="designation"
                value={data?.designation || ""}
                name="designation" // Add a name for the field
                placeholder="Enter your Designation"
                className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
                onChange={(e) =>
                  handleInputChange(e, { column_name: "designation" })
                } // Notify parent of changes
                disabled={require}
                readOnly={require}
              />
            </div>

            <div>
              <div className="flex items-center justify-between">
              <label htmlFor="orgHierarchy" className="block">
                Organisational Hierarchy
              </label>
               {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Organisation Hierarchy",placeholder:"Select your Organisational Hierarchy"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
              </div>
              <select
                id="orgHierarchy"
                value={data?.orgHierarchy || ""}
                name="orgHierarchy" // Add a name for the field
                className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
                onChange={(e) =>
                  handleInputChange(e, { column_name: "orgHierarchy" })
                } // Notify parent of changes
                disabled={require}
                readOnly={require}
              >
                <option>Select your Organisational Hierarchy</option>
                <option value="Owner">Owner</option>
                <option value="ShareHolder">ShareHolder</option>
                <option value="Director">Director</option>
                <option value="Decision Makers">Decision Makers</option>
                <option value="Department Head">Department Head</option>
                <option value="Executive">Executive</option>
              </select>
            </div>

            <div>
              <div className="flex items-center justify-between">
              <label htmlFor="email" className="block">
                Email ID<span className="text-red-500">*</span>
              </label>
               {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Email ID",placeholder:"Enter Your Email ID"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
              </div>
              <input
                type="email"
                value={data?.email || ""}
                id="email"
                name="email" // Add a name for the field
                placeholder="Enter your Email ID"
                className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
                onChange={(e) => handleInputChange(e, { column_name: "email" })} // Notify parent of changes
                disabled={require}
                readOnly={require}
              />
            </div>

            <div>
              <div className="flex items-center justify-between">
              <label htmlFor="primaryContact" className="block">
                Primary Contact Number<span className="text-red-500">*</span>
              </label>
               {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Primary Contact Numbere",placeholder:"Enter Your contact no"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
              </div>
              <input
                type="text"
                id="primaryContact"
                value={data?.primaryContact || ""}
                name="primaryContact" // Add a name for the field
                placeholder="Enter your conatact no"
                className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
                onChange={(e) =>
                  handleInputChange(e, { column_name: "primaryContact" })
                } // Notify parent of changes
                disabled={require}
                readOnly={require}
              />
            </div>
            <div>
              <div className="flex items-center justify-between">
              <label htmlFor="additional_contact_number" className="block">
                Alternative Contact Number
                <span className="text-red-500">*</span>
              </label>
               {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Alternative Contact Number",placeholder:"Enter Your alternative contacrt no"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
              </div>
              <input
                type="text"
                id="additional_contact_number"
                value={data?.additional_contact_number || ""}
                name="additional_contact_number" // Add a name for the field
                placeholder="Alternative Contact Number"
                className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
                onChange={(e) =>
                  handleInputChange(e, {
                    column_name: "additional_contact_number",
                  })
                } // Notify parent of changes
                disabled={require}
                readOnly={require}
              />
            </div>
            <div>
              <div className="flex items-center justify-between">
              <label htmlFor="preferred_instant_messaging_1" className="block">
                Prefered Instant Message - 1
                <span className="text-red-500">*</span>
              </label>
               {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Preffered Instant Message - 1",placeholder:"Select your Prefered Message"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
              </div>
              <select
                id="preferred_instant_messaging_1"
                value={data?.preferred_instant_messaging_1 || ""}
                name="preferred_instant_messaging_1" // Add a name for the field
                className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
                onChange={(e) =>
                  handleInputChange(e, {
                    column_name: "preferred_instant_messaging_1",
                  })
                } // Notify parent of changes
                disabled={require}
                readOnly={require}
              >
                <option>Select your Prefered Message</option>
                <option value="What's App">What's App</option>
                <option value="Wechat">Wechat</option>
                <option value="Director">Director</option>
                <option value="Facebook Messenger">Facebook Messenger</option>
              </select>
            </div>
            <div>
              <div className="flex items-center justify-between">
              <label
                htmlFor="preferred_instant_messaging_1_id"
                className="block"
              >
                Prefered Instant Message - 1 ID
                <span className="text-red-500">*</span>
              </label>
               {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Preffered Instant Message - 1 ID",placeholder:"Enter your preferred instant messaging 1 id"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
              </div>
              <input
                type="text"
                value={data?.preferred_instant_messaging_1_id || ""}
                id="preferred_instant_messaging_1_id"
                name="preferred_instant_messaging_1_id" // Add a name for the field
                placeholder="Enter your preferred instant messaging 1 id"
                className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
                onChange={(e) =>
                  handleInputChange(e, {
                    column_name: "preferred_instant_messaging_1_id",
                  })
                } // Notify parent of changes
                disabled={require}
                readOnly={require}
              />
            </div>
            <div>
              <div className="flex items-center justify-between">
              <label htmlFor="preferred_instant_messaging_2" className="block">
                Prefered Instant Message - 2
                <span className="text-red-500">*</span>
              </label>
               {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Prefered Instant Message - 2",placeholder:"Select your Prefered Message"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
              </div>
              <select
                id="preferred_instant_messaging_2"
                value={data?.preferred_instant_messaging_1 || ""}
                name="preferred_instant_messaging_2" // Add a name for the field
                className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
                onChange={(e) =>
                  handleInputChange(e, {
                    column_name: "preferred_instant_messaging_2",
                  })
                } // Notify parent of changes
                disabled={require}
                readOnly={require}
              >
                <option>Select your Prefered Message</option>
                <option value="What's App">What's App</option>
                <option value="Wechat">Wechat</option>
                <option value="Director">Director</option>
                <option value="Facebook Messenger">Facebook Messenger</option>
              </select>
            </div>
            <div>
              <div className="flex items-center justify-between">
              <label
                htmlFor="preferred_instant_messaging_2_id"
                className="block"
              >
                Prefered Instant Message - 2 ID
                <span className="text-red-500">*</span>
              </label>
               {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Prefered Instant Message - 2 ID",placeholder:"Enter your preferred instant messaging 2 id"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
              </div>
              <input
                type="text"
                value={data?.preferred_instant_messaging_2_id || ""}
                id="preferred_instant_messaging_2_id"
                name="preferred_instant_messaging_2_id" // Add a name for the field
                placeholder="Enter your preferred instant messaging 2 id"
                className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
                onChange={(e) =>
                  handleInputChange(e, {
                    column_name: "preferred_instant_messaging_2_id",
                  })
                } // Notify parent of changes
                disabled={require}
                readOnly={require}
              />
            </div>
            <div>
              <div className="flex items-center justify-between">
              <label htmlFor="personal_linkedIn_page" className="block">
                Personal LinkedIn Page<span className="text-red-500">*</span>
              </label>
               {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Personal LinkedIn Page",placeholder:"Enter your Personal LinkedIn Page"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
              </div>
              <input
                type="text"
                value={data?.email || ""}
                id="personal_linkedIn_page"
                name="email" // Add a name for the field
                placeholder="Enter your Personal LinkedIn Page"
                className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
                onChange={(e) =>
                  handleInputChange(e, {
                    column_name: "personal_linkedIn_page",
                  })
                } // Notify parent of changes
                disabled={require}
                readOnly={require}
              />
            </div>

            {/* Dynamic Fields */}
            {dynamicFields
              .filter((field) => field) // Filter out undefined or null fields
              .map(
                (field) =>
                  field.division == "executive" && (
                    <div key={field.column_name}>
                      <div className="flex justify-between">
                        <label className="block">
                          {field.field_label?.replace(/_/g, " ") ||
                            "Unnamed Field"}
                          {field.is_required && (
                            <span className="text-red-500">*</span>
                          )}
                        </label>
                        <div
                          className={`gap-[5px] ${hidden ? "hidden" : "flex"}`}
                        >
                          <button
                            className="color-[#979797]"
                            type="button"
                            onClick={() => handleOpenEditModal(field)}
                          >
                            <MdOutlineEdit className="color-[#979797]" />
                          </button>
                          <button
                            className="color-[#979797]"
                            type="button"
                            onClick={() => handleDeleteField(field)}
                          >
                            <MdDeleteOutline className="color-[#979797]" />
                          </button>
                        </div>
                      </div>

                      {/* Render Input for text type fields */}
                      {field.field_type === "text" && (
                        <input
                          value={data?.[field.column_name] || ""}
                          type="text"
                          id={field.column_name}
                          name={field.column_name} // Use column_name as the field name
                          placeholder={`Enter ${field.column_name?.replace(
                            /_/g,
                            " "
                          )}`}
                          className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none focus:border-gray-300"
                          onChange={(e) => handleInputChange(e, field)} // Notify parent of changes
                          disabled={require}
                          readOnly={require}
                        />
                      )}

                      {/* Render Input for select type fields */}
                      {field.field_type === "select" && field.options && (
                        <select
                          id={field.column_name}
                          name={field.column_name} // Use column_name as the field name
                          className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none focus:border-gray-300"
                          onChange={(e) => handleInputChange(e, field)} // Notify parent of changes
                          disabled={require}
                          readOnly={require}
                        >
                          <option>
                            Select {field.column_name?.replace(/_/g, " ")}
                          </option>
                          {field.options.map((option, index) => (
                            <option key={index} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      )}

                      {/* Render Input for file type fields */}
                      {field.field_type === "file" && (
                        <input
                          type="file"
                          id={field.column_name}
                          name={field.column_name} // Use column_name as the field name
                          className="mt-1 block w-full p-2 border-2 border-gray-200 rounded-md focus:outline-none focus:border-gray-300"
                          onChange={(e) => handleInputChange(e, field)} // Notify parent of changes
                          disabled={require}
                          readOnly={require}
                        />
                      )}
                    </div>
                  )
              )}
          </form>

          {/* Add Field Button */}
           <div className='grid grid-cols-2 items-center px-10 mt-6'>
          <div className='flex items-center justify-between'>
             <button
              className="bg-oceanBlue text-white font-bold p-2 rounded-[5px]"
              onClick={addExecutive}
            >
              Add More Executive
            </button>
            <button
              onClick={handleOpenModal}
              className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
            >
              Add Field
            </button>
          </div>
          <div className='flex items-center justify-end'>
            <button
              onClick={handleOpenModal}
              className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
            >
              Add Field
            </button>
          </div>
        </div>
        </div>
      ))}

      <FieldEditModal
        isOpen={isEditModalOpen}
        onClose={() => setEditModalOpen(false)}
        onSave={handleSave}
        formData={formData}
        setFormData={setFormData}
        content={"Exec Details"}
      />

      {/* Add Custom Field Modal */}
      <CustomFieldModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSubmit={handleSubmit}
        division={division}
      />

      {/* Edit Custom Field Modal */}
      <EditCustomFieldModal
        isOpen={showEditModal}
        onClose={handleCloseEditModal}
        onSubmit={handleSubmitUpdateField}
        fieldData={selectedField}
      />

      {/* Delete Confirmation Modal */}
      <DeleteConfirmationModal
        isOpen={showDeleteModal}
        onClose={handleCloseDeleteModal}
        onConfirm={handleConfirmDelete}
      />
      <ToastContainer />
    </>
  );
};

export default Executives;
